import { nextTick } from 'vue'
import { createI18n, type I18n } from 'vue-i18n'
import { client } from 'laravel-precognition-vue'
import { getThemeCookie } from '@/utils/vuetify.ts'
import axios from 'axios'

export const SUPPORT_LOCALES = ['en', 'ar'] as const

export type AvailableLocals = typeof SUPPORT_LOCALES[number]

export type I18nExpectedType = I18n<Record<string, unknown>, Record<string, unknown>, Record<string, unknown>, string, false>


let i18n: I18nExpectedType

export function getI18n () {
  const locale = getThemeCookie('language', 'ar')
  if (!i18n) {
    i18n = createI18n({
      locale,
      fallbackLocale: 'en',
      globalInjection: true,
      legacy: false,
      fallbackWarn: false,
      missingWarn: false,
      silentTranslationWarn: true,
      silentFallbackWarn: true,
      // missing (locale, key) {
      //   if (!import.meta.env.DEV) {
      //     return
      //   }
      //   axios.get('/api/force-translate', {
      //     params: {
      //       locale,
      //       key,
      //     },
      //   }).then(response => {
      //     console.log('ai-translation-result', response.data, 'match', response.data?.result)
      //   })
      // },
    }) as I18nExpectedType
    setI18nLanguage(locale as string)
    loadLocaleMessages(i18n.global.locale.value)
  }


  return i18n
}

export function setI18nLanguage (locale: string) {
  if (i18n.global.locale?.value) {
    i18n.global.locale.value = locale
  }

  /**
   * NOTE:
   * If you need to specify the language setting for headers, such as the `fetch` API, set it here.
   * The following is an example for axios.
   *
   * axios.defaults.headers.common['Accept-Language'] = locale
   */
  client.axios().defaults.headers.common['Accept-Language'] = locale
  if (document.querySelector('html')) {
    document.querySelector('html')?.setAttribute('lang', locale)
  }
}

export async function loadLocaleMessages (locale: string) {
  const { data: messages } = await axios.get(`/api/content/i18n/${locale}/web`)
  // set locale and locale message
  i18n.global.setLocaleMessage(locale, messages)

  return nextTick()
}
